import { useCallback, useMemo } from 'react';
import { tasksApi } from './api';
import { TaskFormValues } from './task-form';
import { useStateSelector } from 'shared/store';
import { FormikHelpers } from 'formik';
import { TaskStatusEnum } from 'shared/ui/formik-fields/task-status-picker-field';

export const useAddTaskForm = (onSuccess: () => void) => {
  const [createTask, { isLoading }] = tasksApi.useCreateTaskMutation();
  const currentUser = useStateSelector((s) => s.auth.user);

  const initialValues: TaskFormValues = useMemo(
    () => ({
      theme: '',
      description: '',
      managerId: currentUser?.id ?? null,
      employeeIds: [],
      dueDate: null,
      status: TaskStatusEnum.NEW,
    }),
    [currentUser?.id],
  );

  const handleSubmit = useCallback(
    async (values: TaskFormValues, formikHelpers: FormikHelpers<TaskFormValues>) => {
      try {
        await createTask({
          theme: values.theme,
          description: values.description,
          managerId: values.managerId ?? currentUser?.id,
          employeeIds: values.employeeIds,
          dueDate: values.dueDate ?? undefined,
          status: values.status,
        }).unwrap();
        formikHelpers.resetForm({ values: initialValues });
        onSuccess();
      } finally {
        formikHelpers.setSubmitting(false);
      }
    },
    [createTask, currentUser?.id, initialValues, onSuccess],
  );

  return { initialValues, handleSubmit, isLoading };
};
